module.exports = __webpack_public_path__ + "static/media/fifa2019.97b538d8.jpg";